'use client';

import type { ReactNode } from 'react';
import { FileReadRenderer } from '../../ToolCallsRenderers/renderers/FileReadRenderer';
import { PlainTextRenderer } from '../../ToolCallsRenderers/renderers/PlainTextRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderFileReadResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;

  if (typeof content === 'object' && content !== null) {
    return (
      <FileReadRenderer
        data={
          content as {
            filePath?: string;
            content?: string;
            contentLength?: number;
          }
        }
        maxHeight={maxHeight}
      />
    );
  }

  return <PlainTextRenderer content={String(content)} maxHeight={maxHeight} />;
};
